import Vue from 'vue'
import VueRouter from 'vue-router'
// import goTo from 'vuetify/es5/services/goto'

// import About from '../views/About.vue'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: { name: 'home' }
  },
  {
    path: '/home',
    name: 'home',
    component: () => import(/* webpackChunkName: "about" */ '../views/Home.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/events',
    name: 'events',
    component: () => import(/* webpackChunkName: "Events" */ '../views/Events.vue')
  },
  {
    path: '/legal/',
    name: 'legal',
    component: () => import(/* webpackChunkName: "Legal" */ '../views/Legal.vue')
  },
  {
    path: '/cms_pages/:id',
    name: 'cms_page',
    component: () => import(/* webpackChunkName: "CmsPage" */ '../views/CmsPage.vue')
  },
  {
    path: '/catagories/:id',
    name: 'category',
    component: () => import(/* webpackChunkName: "CmsPage" */ '../views/Category.vue')
  },
  {
    path: '/organisations/:id',
    name: 'organisation',
    component: () => import(/* webpackChunkName: "CmsPage" */ '../views/Organisation.vue')
  },
  {
    path: '/event/:id',
    name: 'event',
    component: () => import(/* webpackChunkName: "CmsPage" */ '../views/Event.vue')
  },
  {
    path: '/organisations/',
    name: 'organisations',
    component: () => import(/* webpackChunkName: "CmsPage" */ '../views/Organisations.vue')
  },
  {
    path: '/contact/',
    name: 'contact',
    component: () => import(/* webpackChunkName: "Contact" */ '../views/Contact.vue')
  },
  {
    path: '/welcome/',
    name: 'welcome',
    component: () => import(/* webpackChunkName: "Welcome" */ '../views/Welcome.vue')
  },
  {
    path: '/terms/',
    name: 'terms',
    component: () => import(/* webpackChunkName: "Terms" */ '../views/Terms.vue')
  },
  {
    path: '/app-terms/',
    name: 'app_terms',
    component: () => import(/* webpackChunkName: "Terms" */ '../views/TermsInApp.vue')
  },
  {
    path: '/app-privacy/',
    name: 'app_privacy',
    component: () => import(/* webpackChunkName: "Search" */ '../views/PrivacyInApp.vue')
  },
  {
    path: '/app-accessibility/',
    name: 'app_accessibility',
    component: () => import(/* webpackChunkName: "Search" */ '../views/AccessibilityInApp.vue')
  },
  {
    path: '/app-search/',
    name: 'search',
    component: () => import(/* webpackChunkName: "Search" */ '../views/AppSearch.vue')
  },
  {
    path: '/favourites',
    name: 'favourites',
    component: () => import(/* webpackChunkName: "Search" */ '../views/Favourites.vue')
  },
  {
    path: '/vips',
    name: 'vips',
    component: () => import(/* webpackChunkName: "Search" */ '../views/Vips.vue')
  },
  {
    path: '/infoandadvice',
    name: 'infoandadvice',
    component: () => import(/* webpackChunkName: "Search" */ '../views/InfoAndAdvice.vue')
  },
  {
    path: '/opportunities',
    name: 'opportunities',
    component: () => import(/* webpackChunkName: "Search" */ '../views/Opportunities.vue')
  },
  {
    path: '/opportunity/:id',
    name: 'Opportunity',
    component: () => import(/* webpackChunkName: "Search" */ '../views/Opportunity.vue')
  },
  {
    path: "/education",
    name: "education",
    component: () =>
      import(/* webpackChunkName: "Education" */ "../views/Education.vue"),
  },
  {
    path: "/education/:id",
    name: "education_article",
    component: () =>
      import(
        /* webpackChunkName: "Education" */ "../views/EducationArticle.vue"
      ),
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      setTimeout(function(){
        window.scroll(0, savedPosition.y);
      }, 50);
      return
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes,
})

export default router